/* assets/preorder-toggle.js
 * Hides #infiniteoptions-container unless the current variant is PRE-ORDER (Timesact).
 * Safe to include site-wide; it no-ops outside product pages.
 */
(function () {
  const CONFIG = {
    targetSel: '.pre-order-container', // what to show/hide
    addBtnSel:
      '.product__submit__buttons [name="add"], button#AddToCart, button[name="add"]', // your main submit
    timesactSel:
      '.timesact-preorder-description, .timesact-button-cs, .timesact-button-bis' // Timesact UI hooks
  };

  function $(s, root) { return (root || document).querySelector(s); }
  function isVisible(el) { return !!el && el.offsetParent !== null; }

  function isPreorderActive() {
    const btn = $(CONFIG.addBtnSel);
    const txt = ((btn && (btn.value || btn.textContent)) || '').toLowerCase();
    if (/\bpre[-\s]?order\b/.test(txt)) return true; // “Pre-order”, “Pre order”, “Preorder”
    const ta = $(CONFIG.timesactSel);
    return isVisible(ta);
  }

  function show(el) { if (!el) return; el.removeAttribute('hidden'); el.style.removeProperty('display'); }
  function hide(el) { if (!el) return; el.setAttribute('hidden', 'true'); el.style.setProperty('display', 'none', 'important'); }

  function update() {
    const target = $(CONFIG.targetSel);
    if (!target) return; // app block not on this template
    (isPreorderActive() ? show : hide)(target);
  }

  function init() {
    // run only on pages with a product form
    if (!$('form[action*="/cart/add"]')) return;

    update();

    // Timesact mutates the ATC area → watch it
    const root = $('.product__submit__buttons') || document.body;
    new MutationObserver(update).observe(root, {
      childList: true, subtree: true, characterData: true, attributes: true
    });

    // re-check on variant selection
    document.addEventListener('change', (e) => {
      if (
        e.target.matches('select[name^="options"], input[name^="options"]') ||
        e.target.closest('variant-selects, variant-radios, [data-product-variants]')
      ) { setTimeout(update, 0); }
    });

    // catch late app init
    let tries = 0;
    const iv = setInterval(() => { update(); if (++tries > 12) clearInterval(iv); }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor hot reload
  document.addEventListener('shopify:section:load', init);
})();
